import { render, staticRenderFns } from "./listLoad.vue?vue&type=template&id=31a910c8&scoped=true&"
import script from "./listLoad.vue?vue&type=script&lang=js&"
export * from "./listLoad.vue?vue&type=script&lang=js&"
import style0 from "./listLoad.vue?vue&type=style&index=0&id=31a910c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a910c8",
  null
  
)

export default component.exports